import React, { useEffect } from 'react'
import './styles.sass'
import { HeaderBarMovile } from 'pages/Header/HeaderNavegacion/HeaderBarMovile';

export default function HeaderSimple(props) {
    const {
        pageClass = "",
        isMobile,
        pagina
    } = props

    useEffect(()=>{
        document.body.classList.remove('is-dark-mode')
    },[])

    return (
        <>
            <header className={`simple ${pageClass}`}>
                <a href="/" className="logoClaroshop" aria-label="logoClaroshop">.</a>


                {isMobile !== "desktop" && pagina === "login" &&
                    <div className="menuPrincipal">
                        <HeaderBarMovile isLoged={false} profile={false} />
                    </div>}
            </header>
        </>
    )
}


export function HeaderHidden() {

    useEffect(()=>{
        document.body.classList.remove('is-dark-mode')
    },[])

    return (
        <header className="hidden"></header>
    )
}